export default __webpack_public_path__ + "static/media/phone-call.fd91cef1.png";